import { render, staticRenderFns } from "./sideBar.vue?vue&type=template&id=bc79906c&scoped=true&"
import script from "./sideBar.vue?vue&type=script&lang=ts&"
export * from "./sideBar.vue?vue&type=script&lang=ts&"
import style0 from "./sideBar.vue?vue&type=style&index=0&id=bc79906c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc79906c",
  null
  
)

export default component.exports